<template>
    <page :empty="!articles.length > 0" :empty-text="empty">
        <template slot="header">
            <h1>Events</h1>
        </template>
        <articles :articles="articles"></articles>
    </page>
</template>

<script type="text/babel">
import articles from './Articles/Listing.vue';
import page from './Page.vue';

export default {
  data() {
    return {
      empty: 'Leider gibt es derzeit keine Termine.',
    };
  },
  components: {
    articles,
    page,
  },
  computed: {
    articles() {
      return this.$store.getters.getEvents;
    },
  },
};
</script>

<style lang="scss">
</style>
